import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { Icon } from '../Icon/Icon.js';
import { Typography } from '../Typography/Typography.js';
import { BaseChip } from './BaseChip.js';
import { isSelected } from './BaseChip.mappers.js';
import { mapBaseChipProps, mapLeadingIcon, mapRatingIconInLabel, mapCaption, mapRatingIconInChip, mapLabel } from './Chip.mappers.js';

/** Chip (Basic variant) allows users to make selections or trigger actions. */
var Chip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var label = props.label,
    state = props.state,
    selection = props.selection,
    size = props.size,
    dismissible = props.dismissible,
    dismissLabel = props.dismissLabel,
    onDismiss = props.onDismiss;
  var baseChipProps = mapBaseChipProps(props);
  var iconProps = mapLeadingIcon(props);
  var ratingPropsInLabelProps = mapRatingIconInLabel(props);
  var captionModel = mapCaption(props);
  var ratingPropsInChipProps = mapRatingIconInChip(props);
  return /*#__PURE__*/React.createElement(BaseChip, _extends({
    "aria-pressed": isSelected(selection),
    state: state,
    selection: selection,
    size: size,
    dismissible: dismissible,
    dismissLabel: dismissLabel,
    onDismiss: onDismiss
  }, baseChipProps, {
    ref: ref
  }), iconProps && /*#__PURE__*/React.createElement(Icon, iconProps), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, mapLabel(props), label), ratingPropsInLabelProps && /*#__PURE__*/React.createElement(Icon, ratingPropsInLabelProps)), captionModel && /*#__PURE__*/React.createElement(Typography, captionModel.typographyProps, captionModel.captionText), ratingPropsInChipProps && /*#__PURE__*/React.createElement(Icon, ratingPropsInChipProps));
});
Chip.defaultProps = {
  dismissible: false,
  type: 'default'
};
var ChipMemoized = /*#__PURE__*/React.memo(Chip);
ChipMemoized.displayName = 'Chip';

export { ChipMemoized as Chip, Chip as ChipWithoutMemoized };
//# sourceMappingURL=Chip.js.map
